import { delay } from './delay';
import { allSettled, PromiseAllSettledType } from './allSettled';

export async function getPromiseResults<T, U>(
  params: T[],
  promiseFn: (...args: T[]) => Promise<U>,
  timeout = 5000,
): Promise<Map<T, U>> {
  const requestList = params.map((param) => {
    const params = Array.isArray(param) ? param : [param];
    return Promise.race([promiseFn(...params), delay(timeout)]);
  });
  const results = await allSettled(requestList);

  return results.reduce(
    (acc: Map<T, U>, item: PromiseAllSettledType<U>, index: number) => {
      if (item.status === 'fulfilled' && item.value) {
        acc.set(params[index], item.value);
      }
      return acc;
    },
    new Map(),
  );
}
